import { render } from "./skillPage.vue?vue&type=template&id=664d28f2"
import script from "./skillPage.vue?vue&type=script&lang=js"
export * from "./skillPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__